<template>
  <highcharts class="chart" :options="options" />
</template>

<script>

export default {
  name: 'WBaseLineExampleChart',
  props: {
    baseLineRule: {
      type: Object,
    },
    baselineData: {
      type: Array,
    },
  },
  data() {
    return {
      ranges: {
        name: '베이스라인',
        data: [],
      },
      logCount: {
        name: '로그발생',
        data: [],
      },
      options: {
        chart: {
          height: 200,
        },
        title: false,
        credits: false,
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value: %H:%M:%S}',
            style: {
              color: '$chinagray',
              fontSize: '9px',
            },
          },
          crosshair: true,
        },
        yAxis: {
          title: false,
        },
        tooltip: {
          xDateFormat: '%Y-%m-%d %H:%M:%S',
          crosshairs: true,
          shared: true,
        },
        legend: false,
        series: [{
          data: [],
          zIndex: 1,
          marker: {
            enabled: false,
            fillColor: 'white',
            lineColor: '#568bd2',
            lineWidth: 2,
          },
        }, {
          data: [],
          type: 'arearange',
          lineWidth: 0,
          linkedTo: ':previous',
          color: '#efb754',
          fillOpacity: 0.3,
          zIndex: 0,
          marker: {
            enabled: false,
          },
        }],
      },
    };
  },
  watch: {
    baselineData: {
      immediate: true,
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.createChartData();
        });
      },
    },
  },
  methods: {
    /**
     * 설정한 상/하한 값으로 베이스라인 미리보기 생성
     * @author leesy918
     * @return {[type]} [description]
     */
    renderChart(range, logCount) {
      const rangeData = { name: '베이스라인', data: range };
      const logCountData = { name: '로그발생', data: logCount };
      rangeData.data.forEach((item) => {
        item[1] -= Math.floor(item[1] * (this.baseLineRule.lowerBound * 0.01));
        item[2] += Math.floor(item[2] * (this.baseLineRule.upperBound * 0.01));
      });
      this.options.series[1].data = rangeData.data;
      this.options.series[1].name = rangeData.name;
      this.options.series[0].data = logCountData.data;
      this.options.series[0].name = logCountData.name;
    },
    /**
     * 현재 시간으로 더미 데이터 작성
     * @author leesy918
     * @return {[type]} [description]
     */
    createChartData() {
      const rangeData = [];
      const logCountData = [];
      this.baselineData.forEach((item) => {
        const baseNode = [item.checkDatetime, item.logCount];
        logCountData.push(baseNode);
        const node = [
          item.checkDatetime,
          item.logCount,
          item.logCount,
        ];
        rangeData.push(node);
      });
      this.renderChart(rangeData, logCountData);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/components/BaseLineExampleChart.vue